import { emptySplitApi, nonUserApi } from './index'

// Public/unauthenticated flows (registration, signup, password recovery/reset).
// These must never send a stale Authorization header from localStorage, so they
// ride on nonUserApi rather than emptySplitApi.
export const authManagementApi = nonUserApi.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/register`,
        method: "POST",
        body: model,
      }),
    }),
    passwordRecovery: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/password-recovery`,
        method: "POST",
        body: model,
      }),
    }),
    passwordRecovery2: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/password-recovery-2`,
        method: "POST",
        body: model,
      }),
    }),
    passwordReset: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/password-reset`,
        method: "POST",
        body: model,
      }),
    }),
    settingUpAccount: builder.mutation({
        query: (model) => ({
          url: `api/v1/auth-service/authManagement/setting-up-account`,
          method: "POST",
          body: model,
        }),
      }),
    confirmRegisterUser: builder.mutation({
        query: (model) => ({
          url: `api/v1/auth-service/authManagement/confirm-register-user`,
          method: "POST",
          body: model,
        }),
      }),
    registerValidation: builder.mutation({
        query: (model) => ({
            url: `api/v1/auth-service/authManagement/register-validation`,
            method: "POST",
            body: model,
        }),
      }),
    resendActivateAccountLink: builder.mutation({
        query: (userId) => ({
          url: `api/v1/auth-service/authManagement/resend-activate-account-link?userId=${userId}`,
          method: "POST",
        }),
    }),
    validateResetPasswordToken: builder.mutation({
        query: (model) => ({
          url: `api/v1/auth-service/authManagement/validate-token`,
          method: "POST",
          body: model
        }),
    }),
    resendResetPasswordLink: builder.mutation({
        query: (userId) => ({
          url: `api/v1/auth-service/authManagement/resend-reset-password-link?userId=${userId}`,
          method: "POST",
        }),
    }),
    signupUser: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/signup-user`,
        method: "POST",
        body: model,
      }),
    }),
    signupOrganization: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/signup-organization`,
        method: "POST",
        body: model,
      }),
    }),
    signupBilling: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/signup-billing`,
        method: "POST",
        body: model,
      }),
    }),
    signupSubscription: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/signup-subscription`,
        method: "POST",
        body: model,
      }),
    }),
    tokenizeCard: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/tokenize-card`,
        method: "POST",
        body: model,
      }),
    }),
  }),
  overrideExisting: false,
});

// Authenticated flows: the caller must already have a valid session, so these
// stay on emptySplitApi (which attaches the Authorization header).
export const authManagementAuthedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    updatePassword: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/authManagement/update-password`,
        method: "POST",
        body: model,
      })
    }),
    isUserFirstTimeLogin: builder.query({
      query: () => ({
        url: `api/v1/auth-service/organization/profile/show-welcome`,
        method: "GET",
      }),
    })
  }),
  overrideExisting: false,
});

export const {
  useRegisterMutation,
  usePasswordRecoveryMutation,
  usePasswordRecovery2Mutation,
  usePasswordResetMutation,
  useSettingUpAccountMutation,
  useConfirmRegisterUserMutation,
  useRegisterValidationMutation,
  useResendActivateAccountLinkMutation,
  useValidateResetPasswordTokenMutation,
  useResendResetPasswordLinkMutation,
  useSignupUserMutation,
  useSignupOrganizationMutation,
  useSignupBillingMutation,
  useSignupSubscriptionMutation,
  useTokenizeCardMutation,
} = authManagementApi;

export const {
  useUpdatePasswordMutation,
  useLazyIsUserFirstTimeLoginQuery,
} = authManagementAuthedApi;
